import { render } from "./InvestmentOwners.vue?vue&type=template&id=06188890"
import script from "./InvestmentOwners.vue?vue&type=script&lang=js"
export * from "./InvestmentOwners.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__